import type { FC } from 'react';
import type { MessageResponse } from '@/entities/conversations';
import { getMessageContentSource } from '../model/messageText';
import { FeedBubble } from './FeedBubble';
import { MessageContent } from './MessageContent';

type Props = {
  /** Событие сработавшего правила или виджет */
  message: MessageResponse;
};

/** Событие правила или виджет: облако правила, без имени участника. */
export const RuleFeedItem: FC<Props> = ({ message }) => (
  <FeedBubble messageId={message.id} kind="rule" createdAt={message.createdAt}>
    <MessageContent source={getMessageContentSource(message)} attachments={message.attachments} />
  </FeedBubble>
);
